// extracted by mini-css-extract-plugin
export default {"grabando":"MensajeGrabando_grabando__paXL-","spinner":"MensajeGrabando_spinner__XgP3x","spin":"MensajeGrabando_spin__J29hy"};